import React from 'react';
import styles from './Section.module.css';

const SupportHelp = () => (
  <div className={styles.contentSection}>
    <div className={styles.sectionTitle}>Support</div>
    <div className={styles.sectionContent}>
      <p>You have a question? Can't find the answer on the website? Don't worry! you can contact our 24-hour online customer support any time, Our customer support team is happy to answer any of your questions.</p>
    </div>
  </div>
);

export default SupportHelp;
